<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
        <v-toolbar dense dark color="primary darken-2">
            <v-toolbar-title>
                <h3> {{get_dialogMain.title}} </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <PlazaForm :model="plaza" :on-success="savePlaza" :on-cancel="cancel" />
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import PlazaForm from '@/components/forms/PlazaForm'
export default {
  props: ['model'],
  data: () => ({
    plaza: {
      registro_patronal: '',
      configuraciones: { complemento: 'no', importe_complemento: 0 }
    }
  }),
  components: {
    PlazaForm
  },
  mounted () {
    if (this.model.id) {
      this.plaza = Object.assign({}, this.model)
    } else {
      this.plaza.registro_patronal = 'G6210639380'
    }
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServiceAction']),
    savePlaza (model) {
      const router = this.get_urls['POST/nomina/config/plazas/store']
      this.postServiceAction({ url: router, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_DATA', 'SET_DATA'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitos!',
        text: 'Se agrego correctamente el registro'
      })
      this.SET_DATA(val)
      this.CLEAR_DATA()
      this.cancel()
    }
  }
}
</script>

<style>

</style>
